// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardTcsWrapperModelsTcsRedemptionListRecordModel {
    static getAttributeTypeMap() {
        return CardTcsWrapperModelsTcsRedemptionListRecordModel.attributeTypeMap;
    }
}
CardTcsWrapperModelsTcsRedemptionListRecordModel.discriminator = undefined;
CardTcsWrapperModelsTcsRedemptionListRecordModel.additionalProperties = false;
CardTcsWrapperModelsTcsRedemptionListRecordModel.attributeTypeMap = [
    {
        "name": "offerType",
        "baseName": "offerType",
        "type": "string"
    },
    {
        "name": "offerTypeDescription",
        "baseName": "offerTypeDescription",
        "type": "string"
    },
    {
        "name": "rollDate",
        "baseName": "rollDate",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "cardActivationDate",
        "baseName": "cardActivationDate",
        "type": "Date"
    },
    {
        "name": "cardEndDate",
        "baseName": "cardEndDate",
        "type": "Date"
    },
    {
        "name": "sponsorNumber",
        "baseName": "sponsorNumber",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "totalBenefitAmount",
        "baseName": "totalBenefitAmount",
        "type": "number"
    },
    {
        "name": "remainingBenefitAmount",
        "baseName": "remainingBenefitAmount",
        "type": "number"
    },
    {
        "name": "totalPaidAmount",
        "baseName": "totalPaidAmount",
        "type": "number"
    },
    {
        "name": "accumulators",
        "baseName": "accumulators",
        "type": "Array<CardTcsWrapperModelsClaimAccumulatorModel>"
    },
    {
        "name": "redemptions",
        "baseName": "redemptions",
        "type": "number"
    },
    {
        "name": "memberNumberStatus",
        "baseName": "memberNumberStatus",
        "type": "string"
    },
    {
        "name": "memberNumberStatusId",
        "baseName": "memberNumberStatusId",
        "type": "string"
    },
    {
        "name": "memberNumberType",
        "baseName": "memberNumberType",
        "type": "string"
    },
    {
        "name": "claims",
        "baseName": "claims",
        "type": "Array<CardTcsWrapperModelsClaimModel>"
    },
];
//# sourceMappingURL=cardTcsWrapperModelsTcsRedemptionListRecordModel.js.map